import React from 'react';
import SvgIcon from '@material-ui/core/SvgIcon';

export default React.memo(
  React.forwardRef((props, ref) => (
    <SvgIcon viewBox="10 10 54 54" {...props} ref={ref}>
      <path
        d="M30.5461 30.5034L28.3521 34.288C30.0252 35.8147 31.6363 36.9026 34.934 37.9129L36.1222 33.5573C33.9641 32.8388 31.7827 31.6259 30.5461 30.5034Z"
        fill="#29ABE1"
      />
      <path
        d="M24.4035 30.8975C24.4035 30.8975 25.544 32.6156 26.0043 32.2051L27.8585 28.4191C25.9976 26.5822 24.4035 23.6184 24.4035 19.5989C24.4035 32.6265 24.4035 26.5737 24.4035 30.8975Z"
        fill="#29ABE1"
      />
      <path
        d="M44.9316 26.7094L55.9031 36.8682L44.9316 47.0269L44.9316 39.357C42.7099 39.3063 40.7076 39.1539 38.9796 38.8745L39.8706 34.288C41.1872 34.4658 43.2036 34.8111 44.9316 34.8365L44.9316 26.7094Z"
        fill="#29ABE1"
      />
      <path
        d="M20.4015 51.1301L24.4035 51.1301C24.758 37.0402 24.4035 22.938 24.4035 8.84436L20.4015 8.84435L20.4015 19.6497C20.4015 29.4361 20.669 40.0776 20.4015 51.1301Z"
        fill="#2B3990"
      />
      <path
        d="M22.4813 59.5759C26.4597 59.5759 29.6848 56.3507 29.6848 52.3723C29.6848 48.3939 26.4597 45.1688 22.4813 45.1688C18.5029 45.1688 15.2777 48.3939 15.2777 52.3723C15.2777 56.3507 18.5029 59.5759 22.4813 59.5759Z"
        fill="#29ABE1"
      />
      <path
        d="M22.4813 55.9741C24.4705 55.9741 26.083 54.3615 26.083 52.3723C26.083 50.3831 24.4705 48.7706 22.4813 48.7706C20.4921 48.7706 18.8795 50.3831 18.8795 52.3723C18.8795 54.3615 20.4921 55.9741 22.4813 55.9741Z"
        fill="white"
      />
    </SvgIcon>
  ))
);
